export const AUTH_LOGIN_URL = '/';
export const AUTH_DASHBOARD_URL = '/dashboard';


// WEBPACK FOOTER //
// ./src/constants/auth.js